import { log } from "../utils/logs";

declare interface TCData {
  gdprApplies: boolean;
  eventStatus?: string;
  tcString: string;
  purpose?: {
    consents: {
      [key: number]: boolean;
    };
  };
}

async function getConsent(): Promise<TCData> {
  return new Promise((resolve, reject) => {
    if (window.__tcfapi && typeof window.__tcfapi === "function") {
      const callback = (tcData: TCData, success: boolean) => {
        if (success) {
          resolve(tcData);
        } else {
          reject("failed to get TCData");
        }
      };

      window.__tcfapi("addEventListener", 2, callback);
    }
    reject("tcfapi not found");
  });
}

// The eventStatus property of the TCData object shall be one of the following:
// - "tcloaded": CMP is loaded and is prepared to surface a TC String to any calling scripts on the page -
// this event status going to be returned on each next page views after user interacted with consent message.
// - "useractioncomplete": whenever a user has confirmed or re-confirmed their choices -
// this event status going to be returned in the same page view after user interacted with consent message
// - "cmpuishown": the UI is surfaced or re-surfaced
const consentShownInCurrentPV = (tcData: TCData) => {
  if (tcData?.eventStatus === "tcloaded") {
    return false;
  }
  if (
    tcData?.eventStatus === "useractioncomplete" ||
    tcData?.eventStatus === "cmpuishown"
  ) {
    return true;
  }

  // if we fall here it means that tcData missed or has unexpected event status, this actually should never happen
  // but if so, we're going to hande this as if TCF API failed
  return false;
};

// define if consent message appears.
export async function consentMessageShown() {
  return getConsent()
    .then((tcData: TCData) => {
      if (!tcData || tcData.gdprApplies === false) {
        return false;
      }
      return consentShownInCurrentPV(tcData);
    })
    .catch((reason) => {
      log(
        "rlink.getConsent",
        {
          version: __SCRIPT_VERSION__,
          pageURL: window.location.href,
          error: reason,
        },
        { severity: 3 }
      );
      return false;
    });
}
